import { StyleSheet, View } from 'react-native';

import { Text } from '@fhs/ui';
import { TempCartPriceMismatchLogger } from '@fhs-legacy/frontend/src/state/cart/temp-cart-price-mismatch-logger';
import { CART_SUBTOTAL } from '@fhs-legacy/frontend/src/utils/test-ids';

import { OriginalPriceDisplay } from '../cart-item/item-profile/item-price/item-price-components';

import { useCartPriceOrder } from './useCartPriceOrder';

type CartSubtotalsProps = {
  baseTotal: number;
  grandTotal: number;
};

export function CartSubtotals({ baseTotal = 0, grandTotal = 0 }: CartSubtotalsProps) {
  const { serverOrder, incentiveApplied } = useCartPriceOrder();
  const formattedGrandTotal = (grandTotal / 100).toFixed(2);

  return (
    <>
      <View style={styles.container}>
        <Text.Heading type="four">Subtotal:</Text.Heading>
        <View style={styles.priceContainer}>
          {incentiveApplied && baseTotal !== grandTotal && (
            <OriginalPriceDisplay subtotalID price={baseTotal} shouldShowStrikeThrough />
          )}
          <Text.Heading type="four" testID={CART_SUBTOTAL}>
            ${formattedGrandTotal}
          </Text.Heading>
        </View>
      </View>
      <View style={[styles.container, { marginBottom: 13 }]}>
        <Text.Paragraph size="md">Taxes and Fees</Text.Paragraph>
        <Text.Paragraph size="md">Calculated at Final Step</Text.Paragraph>
      </View>
      <TempCartPriceMismatchLogger serverOrder={serverOrder} />
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    padding: 16,
    paddingBottom: 4,
    marginHorizontal: 16,
  },
  priceContainer: {
    flexDirection: 'row',
    gap: 9,
    alignItems: 'center',
  },
});
